<template>
    <div id="mediaPopup">
        <div class="list" id="mediaListPopup">
            <div class="item" @click="openLocation" v-if="visitorLocationEnabled">
                <div class="icon">
                    <DynamicSvg color="#ED5023" name="Location" />
                </div>
                <div class="text black">{{ $t("visitorLanguage.submitLocation") }}</div>
            </div>

            <div class="item" @click="() => selectFile()" v-if="visitorFileSendEnabled">
                <div class="icon">
                    <DynamicSvg name="AddFile" />
                </div>
                <div class="text black">{{ $t("visitorLanguage.addFile") }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import DynamicSvg from "../../../common/DynamicSvg.vue";
import _ from "lodash";
import { mapState } from "vuex";

export default {
    name: "MediaPopup",
    components: { DynamicSvg },
    data() {
        return {
            cancels: [],
        };
    },
    computed: {
        ...mapState({
            visitorFileSendEnabled: (state) => _.get(state, "setting.settings.visitorFileSendEnabled", true),
            visitorLocationEnabled: (state) => _.get(state, "setting.settings.visitorLocationEnabled", true),
        }),
    },
    methods: {
        openLocation() {
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

            if (isSafari) {
                if (navigator.geolocation) {
                    const handleSuccess = (position) => {
                        // console.log(position);
                    };

                    const handleError = (error) => {
                        // console.log(error);
                    };

                    const requestLocation = () => {
                        navigator.geolocation.getCurrentPosition(handleSuccess, handleError);
                    };

                    const handlePermissionDenied = () => {
                        alert(this.$t("visitorLanguage.youDidNotAllowLocationAccess"));
                    };

                    const showPermissionDialog = () => {
                        if (confirm(this.$t("visitorLanguage.allowLocationAccess"))) {
                            requestLocation();
                        } else {
                            handlePermissionDenied();
                        }
                    };

                    showPermissionDialog();
                } else {
                    alert(this.$t("visitorLanguage.locationNotSupported"));
                }
            } else {
                this.$emit("openLocation");
            }
        },

        selectFile() {
            document.getElementById("fileInput").click();
            this.$emit("closeMediaPopup");
        },
        mouseEvent() {
            const cb = (e) => {
                if (e.target.offsetParent == null || e.target.offsetParent == undefined) {
                    this.$emit("closeMediaPopup");
                }
                if (!document.getElementById("mediaListPopup").contains(e.target)) {
                    this.$emit("closeMediaPopup");
                }
            };
            window.addEventListener("click", cb);
            this.cancels.push(() => {
                window.removeEventListener("click", cb);
            });
        },
    },
    mounted() {
        setTimeout(() => this.mouseEvent(), 100);
    },
    beforeDestroy() {
        this.cancels.forEach((cb) => cb());
    },
};
</script>

<style lang="scss" scoped>
@keyframes sps-media-pop {
    from {
        opacity: 0;
        transform: translateY(8px) scale(0.97);
    }
    to {
        opacity: 1;
        transform: translateY(0) scale(1);
    }
}

@media (prefers-reduced-motion: reduce) {
    #mediaPopup {
        animation: none !important;
    }
}

#mediaPopup {
    min-width: 210px;
    position: absolute;
    padding: 8px;
    border-radius: var(--sps-radius-lg, 16px);
    // Konumlanma dayanagi ikon kutusu; cubugun tamamini asmasi icin ikonun
    // altinda kalan cubuk dolgusu kadar ek pay veriliyor.
    bottom: calc(100% + 30px);
    right: -8px;
    background-color: #ffffff;
    color: var(--primary-text);
    border: 1px solid rgba(15, 23, 42, 0.08);
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.16), 0 2px 6px rgba(15, 23, 42, 0.08);
    z-index: 20;
    animation: sps-media-pop 160ms cubic-bezier(0.16, 1, 0.3, 1);
    transform-origin: bottom right;

    .list {
        .item {
            display: flex;
            align-items: center;
            padding: 10px;
            border-radius: var(--sps-radius-lg);
            cursor: pointer;
            user-select: none;

            &:not(:last-child) {
                margin-bottom: 15px;
            }

            // Zemin boyanmadan metin rengini degistirmek metni gorunmez yapiyordu;
            // notr tint her temada okunur birakiyor.
            &:hover {
                background-color: rgba(125, 135, 150, 0.14);
            }
            //
            //    .icon {
            //        filter: brightness(0) invert(1);
            //        color: var(--header-text-color) !important;
            //
            //        svg {
            //            color: white !important;
            //            fill: white !important;
            //        }
            //
            //        path {
            //            fill: white !important;
            //            color: white !important;
            //        }
            //    }
            //}

            .text {
                font-size: 15px;
                font-weight: 500;
                line-height: 12px;
                margin-left: 15px;
            }

            .icon {
            }
            .black {
                color: black;
            }
        }
    }
}
.black {
    color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/V2/popup-chat/MediaPopup.vue